import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { trackBookingCtaClick, trackContact } from '../../utils/metaPixel';
// Fix for default marker icon in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});
export function Location() {
  const {
    t
  } = useLanguage();
  const position: [number, number] = [34.0622, -118.3634]; // Wilshire Blvd, Beverly Hills area
  return <section className="py-20 lg:py-28 bg-white" data-id="element-213" data-mp="7abgkrh2hxpm">
      <div className="container mx-auto px-6" data-id="element-214" data-mp="2afcks8de6a2">
        <div className="grid lg:grid-cols-12 gap-16 lg:gap-24 items-center max-w-6xl mx-auto" data-id="element-215" data-mp="2bqboeqvepuu">
          <div className="lg:col-span-4" data-id="element-216" data-mp="3jchxt5o5izjr">
            <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-217" data-mp="3jdjb7gsn3y4n">
              {t('location.eyebrow')}
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-light text-brand-dark mb-12 tracking-tight" data-id="element-218" data-mp="3sabhnh4qc0q1">
              {t('location.heading')}
            </h2>

            <div className="space-y-10" data-id="element-219" data-mp="656dlv0ex9e1">
              <div data-id="element-220" data-mp="64ekcquafnqx">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-221" data-mp="62tzjsxrzj69">
                  {t('location.addressLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80 leading-relaxed" data-id="element-222" data-mp="fv9j2uoq0ft9">
                  6404 Wilshire Blvd
                  <br data-id="element-223" data-mp="jxw1y63eyqeb" />
                  Suite 610
                  <br data-id="element-224" data-mp="ow7g2t0qrn2c" />
                  Los Angeles, CA 90048
                </p>
              </div>

              <div data-id="element-225" data-mp="tv0r8esk31zc">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-226" data-mp="tuil8qg3d9e8">
                  {t('location.phoneLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80" data-id="element-227" data-mp="2kzc6c5c47xas">
                  <a href="tel:+17026604534" onClick={() => trackContact({
                  channel: 'phone'
                })} className="hover:text-brand-dark transition-colors" data-id="element-228" data-mp="2znp1x17aje4r">
                    (702) 660-4534
                  </a>
                </p>
              </div>

              <div data-id="element-229" data-mp="3imb5qnu6zjcd">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-230" data-mp="3ikqbkzbsi2f1">
                  {t('location.hoursLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80 leading-relaxed" data-id="element-231" data-mp="1o78i6vopebc3">
                  {t('location.hours')}
                </p>
              </div>

              <div className="pt-4" data-id="element-232" data-mp="1jb9wjfurf7fd">
                <button onClick={() => {
                trackBookingCtaClick('location');
                document.getElementById('contacto')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/70 hover:text-brand-dark transition-colors inline-flex items-center gap-2 border-b border-brand-gold/40 pb-1" data-id="element-233" data-mp="3uw0qzwqvevlo">
                  {t('nav.cta')} →
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 h-[500px] lg:h-[600px] w-full rounded-[2rem] overflow-hidden border border-brand-stone/50 z-0" data-id="element-234" data-mp="328oekfefc463">
            <MapContainer center={position} zoom={13} scrollWheelZoom={false} className="w-full h-full" data-id="element-235" data-mp="378sm3fxctok6">
              <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" data-id="element-236" data-mp="15e1okaciyltv" />
              <Marker position={position} data-id="element-237" data-mp="2shjg58mk04cy">
                <Popup data-id="element-238" data-mp="2sgi697h9xnwt">
                  Lipo Laser · Beverly Hills <br data-id="element-239" data-mp="2niyovypa4v0n" /> {t('location.address')}
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </div>
    </section>;
}